import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserNetworkType } from 'user/model/user-network.type';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface ConnectToUserNetworkParams {
	readonly auth0UserId: string;
	readonly networkRefreshTokenScope: string;
	readonly networkType: UserNetworkType;
}

@Injectable({ providedIn: 'root' })
export class ConnectToUserNetworkApiMutation extends ApiMutation<
	void,
	ConnectToUserNetworkParams
> {
	client = 'iam';
	document = gql`
		mutation ConnectToUserNetwork(
			$auth0UserId: String!
			$networkType: UserNetworkType!
			$networkRefreshTokenScope: String!
		) {
			connectToUserNetwork(
				auth0UserId: $auth0UserId
				networkType: $networkType
				networkRefreshTokenScope: $networkRefreshTokenScope
			)
		}
	`;
	method = 'connectToUserNetwork';
}
